import type { EmailImportPaperRow } from './paperInboxViewModel';
import {
    getPaperArxivId,
    getPaperReferenceLabel,
    type PaperDisplayInput,
} from './sourceHelpers';

export interface PaperReferenceRow {
    candidate: Pick<EmailImportPaperRow, 'canonical_url' | 'raw_url' | 'paper_resolution_key'>;
    doi: string | null;
    sourceId: number | null;
    sourcePaperId: string | null;
    sourceUrl?: string | null;
    // Backward compatibility for older inbox models that still pass `paperUrl`.
    paperUrl?: string | null;
}

function toDisplayInput(row: PaperReferenceRow): PaperDisplayInput {
    return {
        sourceId: row.sourceId,
        sourcePaperId: row.sourcePaperId,
        doi: row.doi,
        url: row.sourceUrl || row.paperUrl || row.candidate.canonical_url || row.candidate.raw_url || null,
        paperResolutionKey: row.candidate.paper_resolution_key,
    };
}

export function arxivIdFromRow(row: PaperReferenceRow): string | null {
    return getPaperArxivId(toDisplayInput(row));
}

export function paperReferenceLabel(row: PaperReferenceRow): string | null {
    return getPaperReferenceLabel(toDisplayInput(row));
}
